<template>
  <div>
    <v-row>
      <v-breadcrumbs :items="bread" large></v-breadcrumbs>
    </v-row>
    <v-row>
      <v-col lg="12">
        <v-card>
          <v-card-title class="text-center justify-center py-6">
            <h3 class="font-weight-bold display-1">Administrar</h3>
          </v-card-title>
          <v-card-title class="text-center justify-center py-6">
            <h2 class="font-weight-bold display-0">
              {{ operatoria.nombre }}
            </h2>
          </v-card-title>
          <v-card-subtitle class="text-center justify-center py-6">
            <span class="text-muted">{{ estadoTramite }}</span>
          </v-card-subtitle>
          <div hidden>
            {{ mostrarPestania(operatoria.tipo_servicio_id) }}
          </div>
          <template>
            <v-row justify="end" v-if="downloads.length > 0">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="margin-right: 20px; margin-bottom: 10px"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Descargar
                    <v-icon dark right> mdi-chevron-down </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    :disabled="item.url === null"
                    @click="verDescargas(item.key, item.url)"
                    v-for="(item, index) in downloads"
                    :key="index"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
            <v-row justify="end">
              <v-btn
                v-if="operatoria.tipo_servicio_id === 20 && estado_id === 11"
                class="error mr-5 mb-3"
                large
                color="success"
                @click="abrirLegajo()"
                >Abrir Legajo</v-btn
              >
            </v-row>
            <v-row justify="end">
              <v-btn
                v-if="liquidaciones.length === 0"
                class="error mr-5 mb-3"
                large
                @click="eliminarLegajo()"
                >Eliminar Legajo</v-btn
              >
            </v-row>
            <ModalBitacora :lineaCreditoCliente_id="legajo"> </ModalBitacora>
            <ModalSincronizarCliTrilay
              v-show="parseInt(rol) === 9 ? false : true"
              :lineaCreditoCliente_id="legajo"
            >
            </ModalSincronizarCliTrilay>
          </template>
          <v-tabs v-model="tab" background-color="transparent" grow>
            <v-tab to="#cliente" href="#cliente"> Cliente </v-tab>
            <v-tab to="#credito" href="#credito">Solicitud </v-tab>
            <v-tab to="#documentacion" href="#documentacion">
              Documentación
            </v-tab>
            <v-tab
              to="#comprobantes"
              href="#comprobantes"
              v-if="
                tipoCreditoTab == 'desembolso' &&
                parseInt(this.subtipo, 10) === 0 &&
                parseInt(rol) !== 9
                  ? true
                  : false
              "
            >
              Comprobante
            </v-tab>
            <v-tab
              to="#liquidaciones"
              href="#liquidaciones"
              v-if="
                operatoria.id !== 71 &&
                tipoCreditoTab == 'desembolso' &&
                liquidaciones.length > 0 &&
                parseInt(this.subtipo, 10) === 0
              "
            >
              Liquidaciones
            </v-tab>
            <!-- <v-tab
              to="#liquidacion"
              v-if="
                (operatoria.id !== 71 &&
                  tipoCreditoTab == 'enlace' &&
                  lcc.liquidacion_enlace) ||
                (tipoCreditoTab == 'desembolso' &&
                  parseInt(this.subtipo, 10) === 0 &&
                  liquidaciones.length > 0 &&
                  (parseInt(rol) !== 9 ? true : false))
              "
              href="#liquidacion"
            >
              Liquidación
            </v-tab> -->
            <v-tab
              to="#liquidacionesFinanciamiento"
              v-if="
                operatoria.id !== 71 &&
                operatoria.tipo_servicio_id === 13 &&
                parseInt(rol) === 2
              "
              href="#liquidacionesFinanciamiento"
            >
              Liquidación
            </v-tab>
            <v-tab
              to="#liquidacionesAnr"
              v-if="operatoria.tipo_servicio_id === 19"
              href="#liquidacionesAnr"
            >
              Liquidación Anr
            </v-tab>
            <v-tab
              to="#liquidacionesAnticipo"
              v-if="
                operatoria.id === 71 &&
                montoAprobadoOperAnticipo !== null &&
                estado_id
              "
              href="#liquidacionesAnticipo"
            >
              Liquidación Anticipo
            </v-tab>
            <v-tab
              to="#desembolsos"
              v-if="operatoria.tipo_servicio_id === 19"
              href="#desembolsos"
            >
              Desembolsos
            </v-tab>
            <v-tab
              to="#bitacora"
              @click="getBitacora()"
              v-if="this.legajo"
              href="#bitacora"
            >
              Bitácora
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="cliente">
              <v-card class="mt-5" flat>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Campo</th>
                        <th class="text-left">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Legajo</td>
                        <td>{{ legajo || '-' }}</td>
                      </tr>
                      <tr>
                        <td>Apellido</td>
                        <td>{{ cliente.apellido || '-' }}</td>
                      </tr>
                      <tr>
                        <td>Nombre</td>
                        <td>{{ cliente.nombre || '-' }}</td>
                      </tr>
                      <tr>
                        <td>Razon Social</td>
                        <td>{{ cliente.razonSocial || '-' }}</td>
                      </tr>
                      <tr>
                        <td>CUIT/DNI</td>
                        <td>{{ cliente.cuit || cliente.dni || '-' }}</td>
                      </tr>

                      <tr
                        v-if="typeof cliente.sectorProductivo !== 'undefined'"
                      >
                        <td>Localidad</td>
                        <td>{{ cliente.localidad && cliente.localidad.nombre || '-' }}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{{ usuario.email || '-' }}</td>
                      </tr>
                      <tr>
                        <td>Domicilio</td>
                        <td>{{ cliente.domicilioLegal || '-' }}</td>
                      </tr>
                      
                      <tr>
                        <td>Celular</td>
                        <td>{{ cliente.celular || '-' }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-tab-item>
            <v-tab-item value="credito" v-if="this.legajo">
              <v-card class="mt-5" flat>
                <v-card-text>
                  <v-card flat>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Parámetro</th>
                            <th class="text-left">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Nombre</td>
                            <td>{{ operatoria.nombre || '-' }}</td>
                          </tr>
                          <tr>
                            <td>Descripción</td>
                            <td>{{ operatoria.descripcion || '-' }}</td>
                          </tr>
                          <tr>
                            <td>Sector Productivo</td>
                            <td>
                              {{ operatoria.sectorProductivo.nombre || '-' }}
                            </td>
                          </tr>
                          <tr>
                            <td>Fecha de Ingreso</td>
                            <td>
                              <div class="d-flex align-center">
                                <div class="content-area">
                                  <span>
                                    {{ fecha_estado_analisis || '-' }}
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr
                            v-for="(item, index) in clienteParametro"
                            :key="index"
                            v-if="operatoria.id !== 71 && item.tipo_parametro_id"
                          >
                            <td>{{ item.tipo_parametro_id.nombre }}</td>
                            <td>
                              <div class="d-flex align-center">
                                <div class="content-area">
                                  <!-- Modo vista -->
                                  <div
                                    v-if="
                                      !isEditing(item.tipo_parametro_id.clave)
                                    "
                                  >
                                    <span
                                      v-if="
                                        item.tipo_parametro_id.options ===
                                        'float'
                                      "
                                    >
                                      {{ formatter.format(item.valor) }}
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options ===
                                          'month' && item.valor >= 0
                                      "
                                    >
                                      {{ item.valor }} meses
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options === 'int'
                                      "
                                    >
                                      {{ item.valor }}
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options ===
                                        'string'
                                      "
                                    >
                                      {{ item.valor }}
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options !==
                                          'int' &&
                                        item.tipo_parametro_id.options !==
                                          'percent' &&
                                        item.tipo_parametro_id.options !==
                                          'float' &&
                                        item.tipo_parametro_id.options !==
                                          'string' &&
                                        item.tipo_parametro_id.options !==
                                          'month'
                                      "
                                    >
                                      <span v-if="item.valor == 1"
                                        >Mensual</span
                                      >
                                      <span v-if="item.valor == 2"
                                        >Bimestral</span
                                      >
                                      <span v-if="item.valor == 3"
                                        >Trimestral</span
                                      >
                                      <span v-if="item.valor == 4"
                                        >Cuatrimestral</span
                                      >
                                      <span v-if="item.valor == 6"
                                        >Semestral</span
                                      >
                                      <span v-if="item.valor == 12">Anual</span>
                                    </span>
                                    <span v-else>
                                      {{ item.valor }}
                                    </span>
                                  </div>

                                  <!-- Modo edición -->
                                  <div v-else>
                                    <!-- Campo CBU especial - debe ir PRIMERO -->
                                    <v-text-field
                                      v-if="
                                        item.tipo_parametro_id.clave ===
                                        'cbu_financiamiento'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="text"
                                      dense
                                      hide-details
                                      style="max-width: 250px"
                                      maxlength="22"
                                      @input="onCBUInput"
                                      :error="
                                        !isValidCBUField(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      :error-messages="
                                        getCBUErrorMessage(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      hint="CBU debe tener 22 dígitos numéricos"
                                      persistent-hint
                                    ></v-text-field>
                                    <!-- Campo Monto especial -->
                                    <v-text-field
                                      v-else-if="
                                        item.tipo_parametro_id.clave === 'monto'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="text"
                                      dense
                                      hide-details
                                      style="max-width: 200px"
                                      @input="onMontoInput"
                                      :error="
                                        !isValidMontoRange(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      :error-messages="
                                        getMontoErrorMessage(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      hint="Formato: 1.234.567 o 1.234.567,89"
                                      persistent-hint
                                      prefix="$"
                                      placeholder="1.000.000,50"
                                    ></v-text-field>
                                    <!-- Campo Monto Total Solicitado especial -->
                                    <v-text-field
                                      v-else-if="
                                        item.tipo_parametro_id.clave === 'monto_total_solicitado'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="text"
                                      dense
                                      hide-details
                                      style="max-width: 200px"
                                      @input="onMontoInput"
                                      :error="
                                        !isValidMontoRange(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      :error-messages="
                                        getMontoErrorMessage(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      hint="Formato: 1.234.567 o 1.234.567,89"
                                      persistent-hint
                                      prefix="$"
                                      placeholder="1.000.000,50"
                                    ></v-text-field>
                                    <!-- Campo CBU ANR especial -->
                                    <v-text-field
                                      v-else-if="
                                        item.tipo_parametro_id.clave === 'cbu_anr'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="text"
                                      dense
                                      hide-details
                                      style="max-width: 250px"
                                      maxlength="22"
                                      @input="onCBUInput"
                                      :error="
                                        !isValidCBUField(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      :error-messages="
                                        getCBUErrorMessage(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      hint="CBU debe tener 22 dígitos numéricos"
                                      persistent-hint
                                    ></v-text-field>
                                    <!-- Campos numéricos regulares -->
                                    <v-text-field
                                      v-else-if="
                                        item.tipo_parametro_id.options ===
                                          'float' ||
                                        item.tipo_parametro_id.options ===
                                          'int' ||
                                        item.tipo_parametro_id.options ===
                                          'month'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="number"
                                      dense
                                      hide-details
                                      style="max-width: 200px"
                                    ></v-text-field>
                                    <!-- Campo string regular -->
                                    <v-text-field
                                      v-else-if="
                                        item.tipo_parametro_id.options ===
                                        'string'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      dense
                                      hide-details
                                      style="max-width: 250px"
                                    ></v-text-field>
                                    <v-select
                                      v-else
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      :items="periodicidadOptions"
                                      dense
                                      hide-details
                                      style="max-width: 180px"
                                    ></v-select>
                                  </div>
                                </div>

                                <!-- Botones de acción -->
                                <div
                                  class="ml-2"
                                  v-if="
                                    isEditableParameter(
                                      item.tipo_parametro_id.clave
                                    )
                                  "
                                >
                                  <!-- Botón de editar -->
                                  <v-tooltip
                                    bottom
                                    v-if="
                                      !isEditing(item.tipo_parametro_id.clave)
                                    "
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        small
                                        icon
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                          startEdit(
                                            item.tipo_parametro_id.clave,
                                            item.valor,
                                            item
                                          )
                                        "
                                      >
                                        <v-icon small>mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Editar parámetro</span>
                                  </v-tooltip>

                                  <!-- Botones de guardar/cancelar -->
                                  <div v-else class="d-flex">
                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn
                                          small
                                          icon
                                          color="success"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="saveParameterEdit(item)"
                                          class="mr-1"
                                        >
                                          <v-icon small>mdi-check</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Guardar</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn
                                          small
                                          icon
                                          color="error"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="
                                            cancelEdit(
                                              item.tipo_parametro_id.clave
                                            )
                                          "
                                        >
                                          <v-icon small>mdi-close</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Cancelar</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <!-- Operatoria 71 con monto 0: mostrar solo CBU y monto como editables -->
                          <tr
                            v-for="(item, index) in clienteParametro"
                            :key="`op71-${index}`"
                            v-if="
                              operatoria.id === 71 &&
                              item.tipo_parametro_id &&
                              (item.tipo_parametro_id.clave === 'cbu_financiamiento' ||
                                (item.tipo_parametro_id.clave === 'monto' && parseFloat(total) === 0))
                            "
                          >
                            <td>{{ item.tipo_parametro_id.nombre }}</td>
                            <td>
                              <div class="d-flex align-center">
                                <div class="content-area">
                                  <!-- Modo vista -->
                                  <div
                                    v-if="
                                      !isEditing(item.tipo_parametro_id.clave)
                                    "
                                  >
                                    <span
                                      v-if="
                                        item.tipo_parametro_id.options ===
                                        'float'
                                      "
                                    >
                                      {{ formatter.format(item.valor) }}
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options ===
                                          'month' && item.valor >= 0
                                      "
                                    >
                                      {{ item.valor }} meses
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options === 'int'
                                      "
                                    >
                                      {{ item.valor }}
                                    </span>
                                    <span
                                      v-else-if="
                                        item.tipo_parametro_id.options ===
                                        'string'
                                      "
                                    >
                                      {{ item.valor }}
                                    </span>
                                    <span v-else>
                                      {{ item.valor }}
                                    </span>
                                  </div>

                                  <!-- Modo edición -->
                                  <div v-else>
                                    <!-- Campo CBU -->
                                    <v-text-field
                                      v-if="
                                        item.tipo_parametro_id.clave ===
                                        'cbu_financiamiento'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="text"
                                      dense
                                      hide-details
                                      style="max-width: 250px"
                                      maxlength="22"
                                      @input="onCBUInput"
                                      :error="
                                        !isValidCBUField(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      :error-messages="
                                        getCBUErrorMessage(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      hint="CBU debe tener 22 dígitos numéricos"
                                      persistent-hint
                                    ></v-text-field>
                                    <!-- Campo Monto -->
                                    <v-text-field
                                      v-else-if="
                                        item.tipo_parametro_id.clave === 'monto'
                                      "
                                      v-model="
                                        editValues[item.tipo_parametro_id.clave]
                                      "
                                      type="text"
                                      dense
                                      hide-details
                                      style="max-width: 200px"
                                      @input="onMontoInput"
                                      :error="
                                        !isValidMontoRange(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      :error-messages="
                                        getMontoErrorMessage(
                                          editValues[
                                            item.tipo_parametro_id.clave
                                          ]
                                        )
                                      "
                                      hint="Formato: 1.234.567 o 1.234.567,89"
                                      persistent-hint
                                      prefix="$"
                                      placeholder="1.000.000,50"
                                    ></v-text-field>
                                  </div>
                                </div>

                                <!-- Botones de acción -->
                                <div
                                  class="ml-2"
                                  v-if="
                                    isEditableParameter(
                                      item.tipo_parametro_id.clave
                                    )
                                  "
                                >
                                  <!-- Botón de editar -->
                                  <v-tooltip
                                    bottom
                                    v-if="
                                      !isEditing(item.tipo_parametro_id.clave)
                                    "
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        small
                                        icon
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="
                                          startEdit(
                                            item.tipo_parametro_id.clave,
                                            item.valor,
                                            item
                                          )
                                        "
                                      >
                                        <v-icon small>mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Editar parámetro</span>
                                  </v-tooltip>

                                  <!-- Botones de guardar/cancelar -->
                                  <div v-else class="d-flex">
                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn
                                          small
                                          icon
                                          color="success"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="saveParameterEdit(item)"
                                          class="mr-1"
                                        >
                                          <v-icon small>mdi-check</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Guardar</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-btn
                                          small
                                          icon
                                          color="error"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="
                                            cancelEdit(
                                              item.tipo_parametro_id.clave
                                            )
                                          "
                                        >
                                          <v-icon small>mdi-close</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Cancelar</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              v-if="
                                tipoCreditoTab == 'enlace' &&
                                !lcc.liquidacion_enlace
                              "
                            >
                              <v-btn
                                block
                                color="primary"
                                @click="liquidarEnlace"
                              >
                                Liquidar
                              </v-btn>
                            </td>
                          </tr>
                          <tr
                            v-if="
                              estadoTramite === 'Análisis' &&
                              !existeAnticipo &&
                              parseFloat(anticipo) !== 0 &&
                              anticipo
                            "
                          >
                            <td>
                              <v-btn
                                block
                                color="primary"
                                @click="liquidarAnticipo"
                              >
                                Liquidar Anticipo
                              </v-btn>
                            </td>
                          </tr>
                          <tr
                            v-if="
                              operatoria.tipo_servicio_nombre ===
                              'Mendoza Activa'
                            "
                          >
                            <td>
                              <ModalParametrosActiva
                                :legajoId="legajo"
                                :operatoria="operatoria.fideicomiso_id.id"
                                :linea="operatoria"
                                :cuitCbu="cuitCbu"
                                :estado="lcc.estado_id"
                              >
                              </ModalParametrosActiva>
                            </td>
                          </tr>
                          <tr>
                            <td
                              v-if="
                                tipoCreditoTab == 'desembolso' &&
                                liquidaciones.length === 0 &&
                                subtipo === '3'
                              "
                            >
                              <v-btn
                                block
                                color="primary"
                                @click="liquidarSubtipo"
                              >
                                Liquidar
                              </v-btn>
                            </td>
                          </tr>
                          <tr v-if="operatoria.imagenURL">
                            <td>Imagen</td>
                            <td>
                              <v-img
                                class="img-fluid"
                                v-bind:src="operatoria.imagenURL"
                                aspect-ratio="1"
                              ></v-img>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="comprobantes">
              <v-card class="mt-5" flat>
                <v-row>
                  <v-col md="8" lg="8" sm="12">
                    <v-card-text>
                      <ListadoComprobantes
                        :comprobantes="comprobantes"
                        @chkComprobantes="setComprobantes"
                        v-if="listadoFlag"
                      ></ListadoComprobantes>
                      <CargaComprobante
                        :estado="estado_id"
                        :ParametrosCliente="clienteParametro"
                        v-if="!listadoFlag"
                      ></CargaComprobante>
                    </v-card-text>
                  </v-col>
                  <v-col md="4" lg="4" sm="12">
                    <v-card flat>
                      <v-card-text>
                        <div v-if="listadoFlag && this.max_liquidacion > 0">
                          <v-alert text color="info">
                            <b
                              >Liquidaciones restantes
                              {{
                                this.max_liquidacion - this.liquidaciones.length
                              }}</b
                            >
                            <br />
                          </v-alert>
                          <v-alert
                            text
                            :color="
                              !montosLiquidados.excede
                                ? 'success'
                                : 'red dark-red'
                            "
                          >
                            <b> Liquidación / Saldo: <br /> </b>
                            ${{
                              formatMonto(
                                montosLiquidados.liquidados_iva.toFixed(2)
                              )
                            }}
                            / ${{
                              formatMonto(
                                montosLiquidados.restoCompletar.toFixed(2)
                              )
                            }}
                          </v-alert>
                        </div>
                        <v-alert
                          v-if="this.max_liquidacion === 0"
                          border="bottom"
                          icon="mdi-close-octagon"
                          type="error"
                          >Falta parametro Max Liquidación</v-alert
                        >

                        <v-btn
                          block
                          color="primary"
                          v-show="estadoTramite !== 'Cerrado'"
                          @click="liquidar"
                          v-if="listadoFlag"
                          :disabled="
                            comprobante.filter((c) => c.sel === true).length <
                              1 || max_liquidacion - liquidaciones.length === 0
                          "
                        >
                          Liquidar comprobantes
                        </v-btn>
                        <v-btn
                          block
                          color="primary"
                          v-if="!listadoFlag"
                          class="mt-5"
                          @click="getComprobantes()"
                          :loading="loadingComprobantes"
                          >Listado de comprobantes</v-btn
                        >
                        <v-btn
                          class="mt-5"
                          @click="listadoFlag = false"
                          block
                          color="primary"
                          v-if="listadoFlag"
                        >
                          Carga de Comprobantes</v-btn
                        >
                        <v-btn
                          @click="cerrarSolicitud()"
                          v-if="estado_id !== 11"
                          class="mt-5"
                          block
                          color="warning"
                        >
                          Cerrar Solicitud
                        </v-btn>
                        <br />
                        <v-btn color="info" block @click="informe(1)">
                          Reporte de comprobantes
                        </v-btn>
                        <br />
                        <v-btn color="success" block @click="informe(2)">
                          Reporte de comprobantes Excel
                        </v-btn>
                        <br />
                        <EliminarLiquidaciones
                          :legajo="this.legajo"
                        ></EliminarLiquidaciones>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item value="liquidacion">
              <LiquidacionEnlace
                v-if="monto_enlace !== '' || monto_subtipo !== ''"
                :total="monto_enlace"
                :totalsub="monto_subtipo"
              ></LiquidacionEnlace>
            </v-tab-item>
            <v-tab-item value="liquidaciones">
              <ListadoLiquidaciones
                :key="reRender"
                :liquidaciones="liquidaciones"
                :clienteParametro="clienteParametro"
              ></ListadoLiquidaciones>
            </v-tab-item>
            <v-tab-item value="liquidacionesAnr" v-if="lcc.estado_id === 6">
              <LiquidacionAnr
                @monto-cargado="getClienteParametros()"
                :key="reRender"
                :legajo="legajo"
              ></LiquidacionAnr>
            </v-tab-item>
            <v-tab-item value="liquidacionesAnticipo">
              <LiquidacionesAnticipo
                :estado="estado_id"
                :key="reRender"
                :legajo="legajo"
                :max_liquidacion="max_liquidacion"
                :montoAprobado="montoAprobadoOperAnticipo"
              />
            </v-tab-item>
            <v-tab-item value="liquidacionesFinanciamiento">
              <LiquidacionFinanciamiento
                :reRender="reRender"
                :liquidaciones="liquidaciones"
                :gastos="gastos"
                :total="total"
                :legajo="this.legajo"
              ></LiquidacionFinanciamiento>
            </v-tab-item>
            <v-tab-item value="desembolsos" v-if="lcc.estado_id === 6">
              <Desembolsos
                v-if="montoAprobado !== null"
                @listar-liquidaciones="getClienteParametros()"
                :montoMaximo="montoAprobado"
                :legajo="legajo"
                :desembolsos="numero_desembolsos"
              ></Desembolsos>
            </v-tab-item>
            <v-tab-item value="documentacion">
              <v-card flat class="mt-5">
                <v-card-text v-if="documentos.length < 1">
                  Cargando documentos
                </v-card-text>
                <v-card-text v-for="(docs, indexs) in documentos" :key="indexs">
                  <h2>Analisis {{ indexs }}</h2>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Documento Original</th>
                          <th class="text-left">Documento Cliente</th>
                          <th class="text-left">Acciones</th>
                          <th class="text-left" v-show="indexs === 'General'">
                            <v-btn
                              :disabled="!docs.some((ele) => ele.habilitado)"
                              @click="aprobarCambiosSeleccionados()"
                              color="success"
                            >
                              Aprobar Documentación
                            </v-btn>
                            <v-checkbox
                              label="Seleccionar Todos"
                              v-model="habilitarTodos"
                              @change="selectAll"
                              color="info"
                            >
                            </v-checkbox>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in docs
                            .filter((el) => {
                              if (
                                (el.cliente !== '' && !el.original.status) ||
                                (el.cliente === '' && el.original.status)
                              ) {
                                return true;
                              }
                              if (el.cliente === '' && !el.original.status) {
                                return false;
                              }

                              return true;
                            })
                            .filter((el) => el.cliente.client !== 0)"
                          :key="item.original.id"
                        >
                          <td
                            :class="{ 'disabled-row': !item.original.status }"
                          >
                            {{ item.original.nombre }}
                          </td>
                          <td
                            :class="{ 'disabled-row': !item.original.status }"
                          >
                            {{ item.cliente.nombre || ' - ' }}
                          </td>
                          <td>
                            <div class="d-flex justify-space-between">
                              <v-btn
                                :disabled="!item.cliente.id"
                                v-on:click="verDoc(item.cliente.url)"
                                color="success"
                              >
                                <v-icon>mdi-magnify</v-icon>
                              </v-btn>
                              <Validacion
                                v-if="
                                  item.cliente.estado === 0 &&
                                  // item.validacionRol &&
                                  item.original.status
                                "
                                :documento="item"
                                :operatoria="operatoria.id"
                              />
                              <v-chip
                                class="ml-2"
                                v-if="item.cliente.estado === 1"
                                color="warning"
                                v-model="item.cliente.estado"
                              >
                                <v-icon>mdi-check</v-icon>
                              </v-chip>
                              <v-chip
                                class="ml-2"
                                v-if="item.cliente.estado === 2"
                                color="success"
                                v-model="item.cliente.estado"
                              >
                                <v-icon>mdi-check</v-icon>
                              </v-chip>
                            </div>
                          </td>
                          <td>
                            <v-checkbox
                              v-if="
                                item.original.etapa.id !== 6 &&
                                indexs === 'General' &&
                                item.cliente !== ''
                              "
                              :disabled="
                                item.cliente.estado === 2 ||
                                item.cliente.estado === 1
                              "
                              v-model="item.habilitado"
                              :input-value="item.habilitado"
                              color="info"
                              class="mr-20"
                              style="transform: scale(1.2); margin-left: 40px"
                            ></v-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>

              <v-row class="my-container">
                <tr>
                  <td>
                    <v-btn
                      :disabled="listDocumentos.length <= 0"
                      style="margin-right: 20px; margin-bottom: 10px"
                      color="primary"
                      v-on:click="descargarDoc(listDocumentos)"
                    >
                      Descargar Zip
                      <v-icon dark right>mdi-chevron-down</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </v-row>

              <v-row>
                <v-col>
                  <!-- <v-btn
                    block
                    v-if="
                      (estadoTramite == 'Análisis' ||
                        estadoTramite == 'Precalificación' ||
                        estadoTramite == 'Requerimiento') &&
                      !tieneDictamen &&
                      operatoria.nombre !== 'Semilla IV' &&
                      operatoria.nombre !==
                        'ANR fortalecimiento Pyme (CAMARAS)' &&
                      operatoria.nombre !== 'Microcréditos Maipú' &&
                      operatoria.nombre !== 'Docentes Maipú' &&
                      docsSinFiltrar.length > 0 &&
                      this.operatoria.id !== 71 &&
                      docsSinFiltrar.every((el) => el.cliente.estado === 2)
                    "
                    @click="aprobarCambios('Calificación')"
                    color="success"
                  >
                    Calificar
                  </v-btn> -->
                  <v-btn
                    block
                    v-if="
                      (estadoTramite == 'Análisis' ||
                        estadoTramite == 'Precalificación' ||
                        estadoTramite !== 'Calificación') &&
                      !tieneDictamen &&
                      (operatoria.nombre === 'Semilla' ||
                        operatoria.nombre === 'Microcréditos Maipú' ||
                        operatoria.nombre === 'Docentes Maipú') &&
                      docsSinFiltrar.length > 0 &&
                      docsSinFiltrar.every((el) => el.cliente.estado === 2) &&
                      estado_id < 6
                    "
                    @click="aprobarCambios('Aprobado')"
                    color="success"
                  >
                    Aprobar
                  </v-btn>
                  <!-- <v-btn
                    block
                    v-if="
                      (estadoTramite == 'Calificación' ||
                        estadoTramite == 'Requerimiento') &&
                      docsSinFiltrar.length > 0 &&
                      !tieneDictamen &&
                      docsSinFiltrar.every(
                        (el) =>
                          el.cliente.estado === 2 ||
                          el.original.status === false
                      )
                    "
                    @click="aprobarCambios('Aprobado')"
                    color="success"
                  >
                    Aprobar
                  </v-btn> -->
                  <v-btn
                    block
                    v-if="puedeAprobar()"
                    @click="aprobarCambios('Aprobado')"
                    color="success"
                  >
                    Aprobar
                  </v-btn>
                  <v-btn
                    block
                    v-if="puedeObservar()"
                    @click="aprobarCambios('Requerimiento')"
                    color="warning"
                  >
                    Observar
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    block
                    v-if="
                      (docsSinFiltrar.length > 0 &&
                        estadoTramite == 'Análisis') ||
                      estadoTramite == 'Precalificación' ||
                      estadoTramite == 'Calificación' ||
                      estadoTramite == 'Requerimiento'
                    "
                    @click="aprobarCambios('Rechazado')"
                    color="error"
                  >
                    Rechazar
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <SubirDocumento
                    :legajo="legajo"
                    :operatoriaId="operatoria.id"
                    :documentos="documentos"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item value="bitacora">
              <Bitacora
                :bitacora="bitacora ? bitacora : this.bitacora"
              ></Bitacora>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
/* eslint-disable camelcase */
import moment from 'moment';
import { API_URL } from '@/common/config';
import Validacion from '@/components/Validacion.vue';
import LiquidarBtn from '@/components/LiquidarBtn.vue';
import EliminarLiquidaciones from '@/components/EliminarLiquidaciones.vue';
import Bitacora from '@/components/Credito/Bitacora.vue';
import CargaComprobante from '@/components/Comprobantes/NuevoComprobante.vue';
import LiquidacionEnlace from '@/components/Comprobantes/LiquidacionEnlace.vue';
import ListadoComprobantes from '@/components/Comprobantes/ListadoComprobantes.vue';
import ListadoLiquidaciones from '@/components/Comprobantes/ListadoLiquidaciones.vue';
import LiquidacionFinanciamiento from '@/components/Comprobantes/LiquidacionFinanciamiento.vue';
import LiquidacionAnr from '@/components/Comprobantes/LiquidacionAnr.vue';
import LiquidacionesAnticipo from '@/components/Comprobantes/LiquidacionesAnticipo.vue';
import Desembolsos from '@/components/Comprobantes/Desembolsos.vue';
import ModalBitacora from '@/components/ModalBitacora.vue';
import ModalSincronizarCliTrilay from '@/components/ModalSincronicarTrilay.vue';
import ModalParametrosActiva from '@/components/ModalParametrosActiva.vue';
import JSZip from 'jszip';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import xlsx from 'xlsx';
import logo from '@/common/logo';
import ModalGastos from '@/components/Gastos/ModalGastos.vue';
import SubirDocumento from '@/components/Credito/SubirDocumento.vue';
import { showSimpleMessage } from '../../common/util';
import { isValidCBU } from '../../common/validImport';

const axios = require('axios');
import { formatMonto } from '../../common/util';

export default {
  name: 'Legajo',
  components: {
    Bitacora,
    Desembolsos,
    Validacion,
    ModalBitacora,
    LiquidarBtn,
    EliminarLiquidaciones,
    ModalParametrosActiva,
    LiquidacionAnr,
    LiquidacionFinanciamiento,
    CargaComprobante,
    LiquidacionEnlace,
    ListadoComprobantes,
    ListadoLiquidaciones,
    ModalGastos,
    ModalSincronizarCliTrilay,
    SubirDocumento,
    LiquidacionesAnticipo,
  },
  props: [
    'usuario',
    'cliente',
    'operatoria',
    'documentos',
    'docsSinFiltrar',
    'estado_id',
    'downloads',
    'legajo',
  ],
  data: () => ({
    fecha_estado_analisis: null,
    habilitarTodos: false,
    ESTADOS_TRAMITE_APROBACION: [
      'Análisis',
      'Precalificación',
      'Calificación',
      'Requerimiento',
    ],
    cuitCbu: {
      cuit: null,
      cbu: null,
      dni: null,
    },
    estados: ['Rechazado', 'Aprobado', 'Requerimiento'],
    reRender: 0,
    montoAprobado: null,
    montoAprobadoOperAnticipo: null,
    listadoFlag: false,
    bitacora: [],
    token: localStorage.getItem('token'),
    rol: localStorage.getItem('rol'),
    tab: 'cliente',
    estadoTramite: null,
    gastos: [],
    oldLegajo: '',
    liquidaciones: [],
    loadDocumentos: false,
    listDocumentos: [],
    EstadoDocumentos: [],
    listaSolicitudEstado: [],
    comprobantes: [],
    comprobante: [],
    bread: [
      {
        text: 'Mendoza Fiduciaria',
        disabled: false,
        href: '/',
      },
      {
        text: 'Ver crédito',
        disabled: true,
        href: '/catalogo',
      },
    ],
    tipoCredito: '',
    credito_id: '',
    mensaje: '',
    loading: false,
    fileOff: true,
    tipo_comprobante: '',
    comprobantesReporte: [],
    nro_comprobante: '',
    neto_iva: '',
    total: '',
    montoTotalSolicitado: 0,
    loadingAprobar: false,
    loadingRechazar: false,
    success: false,
    error: false,
    operId: null,
    tipoCreditoTab: '',
    nombreArchivo: [],
    reintegro_total: 0,
    loadingComprobantes: false,
    clienteParametro: [],
    tieneDictamen: false,
    lcc: '',
    monto_enlace: '',
    monto_subtipo: '',
    liquidacionSub: '',
    subtipo: '',
    existeAnticipo: false,
    anticipo: false,
    numero_desembolsos: 0,
    max_liquidacion: 0,
    monto_max: 0,
    monto_min: 0,
    monto_max_anr: 0,
    monto_min_anr: 0,
    formatter: new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
    }),
    // Edit functionality
    editMode: {
      fechaCreacion: false,
      cbu_financiamiento: false,
    },
    editValues: {
      fechaCreacion: '',
      cbu_financiamiento: '',
    },
    periodicidadOptions: [
      { text: 'Mensual', value: 1 },
      { text: 'Bimestral', value: 2 },
      { text: 'Trimestral', value: 3 },
      { text: 'Cuatrimestral', value: 4 },
      { text: 'Semestral', value: 6 },
      { text: 'Anual', value: 12 },
    ],
    editableParameters: [
      'monto',
      'plazo_credito',
      'periodicidad_pagos',
      'cbu_financiamiento',
      'cbu_anr',
      'monto_aprobado',
      'liquidacion_aprobada',
      'monto_total_solicitado',
    ],
  }),
  watch: {
    operatoria() {
      // Renderizar el componente
      this.$forceUpdate();
      this.getClienteParametros();
      this.getGastos();
      if (this.operatoria.tipo_servicio_id !== 13) {
        this.getLiquidaciones();
      }
    },

    subtipo(val) {
      switch (val) {
        case '3':
          // Logica para subtipo 3 (Cultural y Turismo)
          this.clienteParametro = this.clienteParametro.filter(
            (c) => c.tipo_parametro_id.clave !== 'liquidacion_aprobada'
          );

          break;
        default:
          break;
      }
    },
    legajo() {
      // Si el legajo cambia, ejecutar getLegajo()
      if (this.legajo !== this.oldLegajo) {
        this.getLcc();
        this.getBitacora();
        this.oldLegajo = this.legajo;
      }

      // Renderizar el componente
      this.$forceUpdate();
    },
  },
  methods: {
    // Edit functionality methods
    isEditableParameter(clave) {
      return this.editableParameters.includes(clave);
    },

    isEditing(field) {
      return this.editMode[field] || false;
    },

    debugEditMode() {
      return this.editMode;
    },

    startEdit(field, currentValue, item = null) {
      console.log(
        'Starting edit for:',
        field,
        'with value:',
        currentValue,
        'item:',
        item
      );
      this.$set(this.editMode, field, true);

      // Formatear el valor según el tipo de campo
      let formattedValue = currentValue;
      if (field === 'monto' || field === 'monto_total_solicitado') {
        // Convertir el monto del backend al formato argentino para mostrar
        formattedValue = this.convertMontoFromBackend(currentValue);
      }

      this.$set(this.editValues, field, formattedValue);

      if (item) {
        this.currentEditingItem = item;
      }
    },

    cancelEdit(field) {
      this.$set(this.editMode, field, false);
      this.$delete(this.editValues, field);
    },

    // CBU validation methods
    onCBUInput(event) {
      // Obtener el valor del input
      const inputValue = event.target ? event.target.value : event;
      // Remover todo lo que no sean números
      const numericValue = inputValue.replace(/\D/g, '');
      
      // Determinar qué campo CBU se está editando
      const currentCBUField = Object.keys(this.editMode).find(key => 
        this.editMode[key] && (key === 'cbu_financiamiento' || key === 'cbu_anr')
      );
      
      if (currentCBUField) {
        // Actualizar el valor sin caracteres no numéricos
        this.$set(this.editValues, currentCBUField, numericValue);
      }
    },

    isValidCBUField(cbu) {
      if (!cbu || cbu === '') return true; // Campo vacío es válido durante la edición
      return isValidCBU(cbu);
    },

    getCBUErrorMessage(cbu) {
      if (!cbu || cbu === '') return '';
      if (!isValidCBU(cbu)) {
        if (cbu.length !== 22) {
          return `CBU debe tener exactamente 22 dígitos (actual: ${cbu.length})`;
        }
        return 'CBU inválido';
      }
      return '';
    },

    // Monto formatting methods
    onMontoInput(event) {
      const inputValue = event.target ? event.target.value : event;
      // Remover todo excepto números, comas y puntos
      let cleanValue = inputValue.replace(/[^\d,.]/g, '');

      // Formatear como moneda argentina (1.234.567,89)
      const formattedValue = this.formatMontoInput(cleanValue);

      // Determinar qué campo de monto se está editando
      const currentMontoField = Object.keys(this.editMode).find(key => 
        this.editMode[key] && (key === 'monto' || key === 'monto_total_solicitado')
      );
      
      if (currentMontoField) {
        // Actualizar el valor formateado
        this.$set(this.editValues, currentMontoField, formattedValue);
      }
    },

    // Validación de rango de monto (general)
    isValidMontoRange(montoArgentino) {
      if (!montoArgentino || montoArgentino === '') return true; // Campo vacío es válido durante la edición

      // Determinar qué campo se está validando
      const currentMontoField = Object.keys(this.editMode).find(key => 
        this.editMode[key] && (key === 'monto' || key === 'monto_total_solicitado')
      );
      
      // Convertir formato argentino a número
      const montoNumerico = this.convertMontoToBackend(montoArgentino);
      const numero = parseFloat(montoNumerico);

      if (isNaN(numero)) return true; // Si no es número válido, no validar rango (otros validadores se encargarán)

      // Usar rangos específicos según el campo
      if (currentMontoField === 'monto_total_solicitado') {
        return numero >= this.monto_min_anr && numero <= this.monto_max_anr;
      } else {
        // Para 'monto' usar los rangos generales
        return numero >= this.monto_min && numero <= this.monto_max;
      }
    },

    getMontoErrorMessage(montoArgentino) {
      if (!montoArgentino || montoArgentino === '') return '';

      // Determinar qué campo se está validando
      const currentMontoField = Object.keys(this.editMode).find(key => 
        this.editMode[key] && (key === 'monto' || key === 'monto_total_solicitado')
      );
      
      const montoNumerico = this.convertMontoToBackend(montoArgentino);
      const numero = parseFloat(montoNumerico);

      if (isNaN(numero)) return 'Ingrese un monto válido';

      // Usar rangos y mensajes específicos según el campo
      if (currentMontoField === 'monto_total_solicitado') {
        if (numero < this.monto_min_anr) {
          return `El monto mínimo ANR es ${this.formatter
            .format(this.monto_min_anr)
            .replace('ARS', '')
            .trim()}`;
        }
        
        if (numero > this.monto_max_anr) {
          return `El monto máximo ANR es ${this.formatter
            .format(this.monto_max_anr)
            .replace('ARS', '')
            .trim()}`;
        }
      } else {
        // Para 'monto' usar los rangos generales
        if (numero < this.monto_min) {
          return `El monto mínimo es ${this.formatter
            .format(this.monto_min)
            .replace('ARS', '')
            .trim()}`;
        }
        
        if (numero > this.monto_max) {
          return `El monto máximo es ${this.formatter
            .format(this.monto_max)
            .replace('ARS', '')
            .trim()}`;
        }
      }

      return '';
    },

    formatMontoInput(value) {
      if (!value) return '';

      // Separar parte entera y decimales si hay coma
      let parts = value.split(',');
      let integerPart = parts[0].replace(/\./g, ''); // Remover puntos de separadores de miles
      let decimalPart = parts[1] || '';

      // Si no hay parte entera, retornar vacío
      if (!integerPart) return '';

      // Limitar decimales a 2 dígitos
      if (decimalPart.length > 2) {
        decimalPart = decimalPart.substring(0, 2);
      }

      // Formatear la parte entera con separadores de miles
      let formattedInteger = new Intl.NumberFormat('es-AR').format(
        parseInt(integerPart)
      );

      // Agregar decimales si existen
      if (decimalPart) {
        return formattedInteger + ',' + decimalPart;
      }

      return formattedInteger;
    },

    // Convertir formato argentino a formato backend (para enviar)
    convertMontoToBackend(montoArgentino) {
      if (!montoArgentino) return '';

      // Ejemplo: "1.234.567,89" -> "1234567.89"
      // Remover puntos (separadores de miles)
      let withoutThousandsSeparator = montoArgentino.replace(/\./g, '');
      // Reemplazar coma por punto (separador decimal)
      let backendFormat = withoutThousandsSeparator.replace(',', '.');

      return backendFormat;
    },

    // Convertir formato backend a formato argentino (para mostrar)
    convertMontoFromBackend(montoBackend) {
      if (!montoBackend) return '';

      // Ejemplo: "1234567.89" -> "1.234.567,89"
      // o "1234567" -> "1.234.567"
      let num = parseFloat(montoBackend);

      // Si el número tiene decimales, mostrarlos, sino no
      let hasDecimals =
        montoBackend.toString().includes('.') &&
        parseFloat(montoBackend) % 1 !== 0;

      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(num);
    },

    async saveParameterEdit(item) {
      try {
        let newValue = this.editValues[item.tipo_parametro_id.clave];

        // Validación especial para CBU (financiamiento y ANR)
        if (item.tipo_parametro_id.clave === 'cbu_financiamiento' || 
            item.tipo_parametro_id.clave === 'cbu_anr') {
          if (!isValidCBU(newValue)) {
            this.$swal.fire({
              icon: 'error',
              title: 'CBU inválido',
              text: 'El CBU debe tener exactamente 22 dígitos numéricos',
            });
            return;
          }
        }

        // Validación y conversión especial para Montos
        if (item.tipo_parametro_id.clave === 'monto' || 
            item.tipo_parametro_id.clave === 'monto_total_solicitado') {
          // Validar rango antes de procesar
          if (!this.isValidMontoRange(newValue)) {
            this.$swal.fire({
              icon: 'error',
              title: 'Monto inválido',
              text: this.getMontoErrorMessage(newValue),
            });
            return;
          }

          // Convertir formato argentino (1.234.567,89) a formato backend (1234567.89)
          newValue = this.convertMontoToBackend(newValue);
          console.log(`${item.tipo_parametro_id.clave} convertido para backend:`, {
            original: this.editValues[item.tipo_parametro_id.clave],
            converted: newValue,
          });
        }

        // API call para actualizar el parámetro
        const url = `${API_URL}api/v1/clientes-parametros/${item.id}`;
        const data = {
          valor: newValue.toString(),
        };
        const header = {
          headers: {
            token: this.token,
          },
        };

        const response = await axios.patch(url, data, header);

        if (response.data.status === 'success') {
          // Actualizar el valor local
          item.valor = newValue;

          this.$swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: 'El parámetro se actualizó correctamente',
            timer: 2000,
            showConfirmButton: false,
          });

          this.cancelEdit(item.tipo_parametro_id.clave);
          // Refrescar datos
          this.getClienteParametros();
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        console.error('Error saving parameter:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo guardar el parámetro',
        });
      }
    },

    async updateOperatoriaField(field, value) {
      console.log(
        ' this.clienteParametro',
        this.clienteParametro,
        'field',
        field,
        'value',
        value
      );
      // Método para actualizar campos de operatoria
      // const url = `${API_URL}api/v1/clientes-parametros/${}`;
      // const data = {
      //   id: this.operatoria.id,
      //   [field]: value,
      // };
      // const header = {
      //   headers: {
      //     token: this.token,
      //   },
      // };

      // const response = await axios.put(url, data, header);
      // return response.data;
    },

    selectAll() {
      this.documentos.General.forEach((doc) => {
        if (
          doc.cliente !== '' &&
          doc.cliente.estado !== 2 &&
          doc.cliente.estado !== 1 &&
          doc.documento_maestro.tipo_analisis === 'General'
        ) {
          doc.habilitado = this.habilitarTodos;
        }
      });
    },
    puedeAprobar() {
      return (
        !this.tieneDictamen &&
        this.ESTADOS_TRAMITE_APROBACION.includes(this.estadoTramite) &&
        this.docsSinFiltrar.length > 0 &&
        this.docsSinFiltrar.every(
          (el) =>
            el.cliente.estado === 2 ||
            el.original.etapa.id === 6 ||
            !el.original.status
        )
      );
    },
    puedeObservar() {
      return (
        ['Análisis', 'Precalificación', 'Calificación'].includes(
          this.estadoTramite
        ) &&
        this.docsSinFiltrar.length > 0 &&
        this.operatoria.id !== 71 &&
        this.docsSinFiltrar.some((el) => el.cliente.estado === 1)
      );
    },
    puedeObservarDeshabilitado() {
      return this.docsSinFiltrar.some(
        (el) => el.cliente.estado === 0 && el.original.etapa.id === 6
      );
    },
    async abrirLegajo() {
      this.$swal
        .fire({
          title: '¿Esta seguro?',
          text: 'El legajo pasara a estado "Análisis"',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#007e33',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Confirmar',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const query = {
              method: 'put',
              url: `${API_URL}api/servicio/clientes`,
              headers: {
                token: this.token,
              },
              data: {
                lineaCreditoCliente_id: this.legajo,
                estado: 3,
              },
            };
            const {
              data: { status, message },
            } = await axios(query);
            if (status === 'error') console.error(message);
            if (status === 'success') {
              await this.$swal.fire(
                'Exito!!',
                'El legajo en estado Análisis',
                'success'
              );
              this.estado_id = 3;
              this.getListaSolicitudEstado();
            }
          }
        });
    },
    async liquidarAnticipo() {
      const montoAprobado = this.clienteParametro.find(
        (el) => el.tipo_parametro_id.id === 48
      ).valor;
      const montoAnticipo = montoAprobado * parseFloat(this.anticipo);
      const query = {
        method: 'post',
        url: `${API_URL}api/liquidacion/anticipo`,
        headers: {
          token: this.token,
        },
        data: {
          lccId: this.legajo,
          anticipo: montoAnticipo,
        },
      };
      const {
        data: { status, message },
      } = await axios(query);
      if (status === 'error') console.error(message);
      if (status === 'success') {
        await this.$swal.fire(
          'Liquidado',
          'El anticipo ha sido liquidado.',
          'success'
        );
        this.$router.go(0);
      }
    },
    eliminarLegajo() {
      this.$swal
        .fire({
          title: '¿Esta seguro?',
          text: 'Si borra el legajo no se podra recuperar',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#007e33',
          cancelButtonColor: '#d33',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Eliminar',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const query = {
              method: 'post',
              url: `${API_URL}api/lineaCreditoClientes/eliminarLegajo`,
              headers: {
                token: this.token,
              },
              data: {
                lineaCreditoCliente_id: this.legajo,
              },
            };
            const {
              data: { status, message },
            } = await axios(query);
            if (status === 'error') console.error(message);
            if (status === 'success') {
              await this.$swal.fire(
                'Eliminado!',
                'El legajo a sido eliminado.',
                'success'
              );
              this.$router.push('/');
            }
          }
        });
    },
    moment() {
      return moment();
    },
    async informe(tipo) {
      const query = {
        method: 'post',
        url: `${API_URL}api/comprobante/liquidadosLegajo`,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: {
          lineacreditocliente_id: this.legajo,
        },
      };
      const {
        data: { status, comprobantes },
      } = await axios(query);
      if (status === 'success') this.comprobantesReporte = comprobantes;
      this.exportPdf(tipo);
    },
    exportPdf(tipo) {
      const doc = new JsPDF('l', 'mm', [297, 410]);
      const columnsHands = Object.keys(this.comprobantesReporte[0]).map(
        (el) => {
          const title = el
            .replace('nro', 'Nº')
            .replace('_', ' ')
            .replace(/(^\w|\s\w)/g, (l) => l.toUpperCase());
          return { title, dataKey: el };
        }
      );
      const height = 50;
      const imgData = logo;
      doc.addImage(imgData, 'PNG', 10, 5, 48, 20);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text(`Informe Comprobantes Legajo N° ${this.legajo}`, 15, 30);
      doc.setFontSize(13);
      doc.text(
        `Ticket N° ${
          this.clienteParametro.find((el) => el.tipo_parametro_id.id === 44)
            .valor
        }`,
        15,
        36
      );
      doc.setFontSize(13);
      doc.text(
        `Monto Inversion Aprobada: $ ${
          this.clienteParametro.find((el) => el.tipo_parametro_id.id === 48)
            .valor
        }`,
        15,
        42
      );
      doc.setFontSize(13);
      doc.text(
        `Monto Reintegro: $ ${
          this.clienteParametro.find((el) => el.tipo_parametro_id.id === 45)
            .valor
        }`,
        15,
        48
      );
      doc.setFontSize(13);
      doc.text(`Fecha: ${moment().format('DD/MM/YYYY')}`, 150, 30);
      doc.setFontSize(15);
      doc.text(`Periodo: ${moment().format('DD/MM/YYYY')}`, 15, 54);
      doc.autoTable(columnsHands, this.comprobantesReporte, {
        startY: height,
        columnStyles: { text: { cellWidth: 'auto' } },
      });
      if (tipo === 0) {
        window.open(doc.output('bloburl'), '_blank');
      }
      if (tipo === 1) {
        doc.save(`Informe Comprobantes ${moment().format('DD/MM/YYYY')}.pdf`);
        // this.$emit('update:visibleModalInformeComprobante', false);
      }
      if (tipo === 2) {
        const informes = this.comprobantesReporte.map((el) => {
          const row = columnsHands.reduce((acc, e) => {
            acc[e.title] = el[e.dataKey];
            return acc;
          }, {});
          return row;
        });
        const ws = xlsx.utils.json_to_sheet(informes);
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, ws, 'People');
        xlsx.writeFile(
          wb,
          `Informe Comprobantes ${moment().format('DD/MM/YYYY')}.xlsx`
        );
      }
    },
    setComprobantes(datos) {
      this.comprobante = datos;
    },
    async getClienteParametros() {
      const url = `${API_URL}api/clienteParametros`;
      const header = {
        headers: {
          token: this.token,
        },
      };
      const data = {
        lineaCreditoCliente_id: this.legajo,
      };
      axios.post(url, data, header).then((response) => {
        this.clienteParametro = response.data.ClienteParametro || [];

    
        // Mostrar cada parámetro individualmente
        this.clienteParametro.forEach((param, index) => {
  
          if (param.tipo_parametro_id) {
            console.log('    - Clave:', param.tipo_parametro_id.clave);
            console.log('    - Nombre:', param.tipo_parametro_id.nombre);
          } else {
            console.warn('    ⚠️ tipo_parametro_id es NULL');
          }
        });
      

        // Validando por tipo de operatoria/categoria (tipo_servicio_id) Programa ENLACE

        if (this.liquidaciones.length > 0) {
          this.monto_subtipo = this.liquidaciones[0].total;
        }

        if (this.clienteParametro.length === 0) {
          return;
        }
        const getParametroByClave = (clave) => {
        console.log(clave, 'this.clienteParametro', this.clienteParametro)
          const foundParam = this.clienteParametro.find(
            (param) => param.tipo_parametro_id && param.tipo_parametro_id.clave === clave
          );

          return foundParam ? foundParam.valor : null;
        };
        this.cuitCbu.dni =
          parseInt(getParametroByClave('dni_representante')) || 0;
        this.cuitCbu.cuit = parseInt(getParametroByClave('cuit')) || 0;
        this.cuitCbu.cbu = getParametroByClave('cbu') || '';

        this.monto_enlace = getParametroByClave('monto_enlace');
        this.total = getParametroByClave('monto');
        this.montoTotalSolicitado = getParametroByClave(
          'monto_total_solicitado'
        );
        const montoAprobado = getParametroByClave('monto_aprobado');
        this.montoAprobado = montoAprobado || null;
        const montoAprobadoOperAnticipo = getParametroByClave('monto');
        this.montoAprobadoOperAnticipo = montoAprobadoOperAnticipo || null;

        if (response.data.status === 'error') {
          this.$swal.fire(
            'Ocurrió un error',
            'No se pudieron obtener los parametros ingresados por el cliente',
            'warning'
          );
        }
      });

      this.reRender += 1;
    },
    verDoc(url) {
      window.open(url);
    },
    verDescargas(prefix, url) {
      const docUrl = `${API_URL}${prefix}${url}`;
      window.open(docUrl);
    },
    getBitacora() {
      // Deje este if que valida el valor de this.operatoria.id porque a veces viene undefined
      const url = `${API_URL}api/bitacora/${this.legajo}`;
      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios.get(url, header).then((response) => {
        this.bitacora = response.data.bitacora.reverse();
      });
    },
    getEstadoAnalisis() {
      const url = `${API_URL}api/v1/bitacoradocumentacion/legajo/${this.legajo}`;
      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios.get(url, header).then((response) => {
        this.fecha_estado_analisis = response.data.response
          ? response.data.response
          : '';
      });
    },
    getListaSolicitudEstado() {
      const url = `${API_URL}api/solicitudEstado`;
      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios.get(url, header).then((response) => {
        this.listaSolicitudEstado = response.data.solicitudEstado;
        this.getEstadoTramite();
      });
    },
    getEstadoTramite() {
      this.estadoTramite = this.listaSolicitudEstado.filter(
        (el) => el.id === parseInt(this.estado_id, 10)
      )[0].nombre;
    },
    async setEstadoTramite(nombreEstado, comentario = '') {
      const estado = this.listaSolicitudEstado.filter(
        (el) => el.nombre === nombreEstado
      );
      const lineacreditoClienteId = this.legajo;

      const formData = {
        lineaCreditoCliente_id: lineacreditoClienteId,
        estado: estado[0].id,
        cliente_id: this.cliente.id,
        operatoria: this.operatoria.id,
        comentario,
      };
      const header = {
        headers: {
          token: this.token,
        },
      };
      await axios
        .put(`${API_URL}api/servicio/clientes`, formData, header)
        .then((response) => {
          this.cliente = response.data.cliente;
          this.alert = true;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$router.push('/');
    },
    async setEstadoDocumentacion() {
      const promesas = this.documentos.General.filter(
        (doc) => doc.habilitado
      ).map((doc) => {
        const data = {
          observaciones: `${doc.cliente.nombre} - Documento aprobado`,
          documentacionCliente_id: doc.cliente.documentacion_id,
          cliente_id: doc.cliente.cliente_id,
          lineaCreditoCliente_id: this.legajo,
        };

        const url = `${API_URL}api/documentacionClientes`;
        const header = {
          headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('token'),
          },
        };
        return axios.put(url, data, header);
      });

      try {
        const respuestas = await Promise.all(promesas);
        // Procesar las respuestas de cada petición
        let success = true;
        for (const respuesta of respuestas) {
          if (respuesta.data.status !== 'success') {
            success = false;
            this.error = true;
            this.errorMensaje = respuesta.data.message;
            break; // Salir del bucle si hay un error
          }
        }
        if (success) {
          this.loading = false;
          this.success = true;
          this.error = false;
          this.resetForm();
        }
      } catch (error) {
        console.error('Error en al menos una petición:', error);
        this.loading = false;
        this.error = true;
      } finally {
        this.dialog = false;
        this.$router.go(`${this.$router.currentRoute}#documentacion`);
      }
    },

    async aprobarCambiosSeleccionados() {
      this.$swal
        .fire({
          title: '¿Confirmas los cambios?',
          showCancelButton: true,
          confirmButtonColor: '#388e3c',
          cancelButtonColor: '#d32f2f',
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Salir',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.setEstadoDocumentacion();
          }
        });
    },
    async aprobarCambios(nombreEstado) {
      let comentario = '';

      if (this.estados.includes(nombreEstado)) {
        const { value: inputValue } = await this.$swal.fire({
          title: `Motivo`,
          input: 'textarea',
          inputLabel: `Ingresa el motivo: ${nombreEstado}`,
          inputPlaceholder: 'Escribe aquí...',
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (inputValue) {
          comentario = inputValue;
          console.log(comentario);
        } else if (nombreEstado === 'Rechazado' && inputValue.trim() === '') {
          showSimpleMessage('Alerta', 'Debe ingresar un motivo', 'info', 3000);
          return;
        }
      }
      this.$swal
        .fire({
          title: '¿Confirmas los cambios?',
          showCancelButton: true,
          confirmButtonColor: '#388e3c',
          cancelButtonColor: '#d32f2f',
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Salir',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.setEstadoTramite(nombreEstado, comentario);
          }
        });
    },
    async mostrarPestania(tipoServicioId) {
      if (tipoServicioId !== null && typeof tipoServicioId !== 'undefined') {
        switch (tipoServicioId) {
          case 13:
            this.tipoCreditoTab = 'credito';
            break;
          case 20:
            this.tipoCreditoTab = 'desembolso';
            break;
          case 23:
            this.tipoCreditoTab = 'enlace';
            break;
          default:
            this.tipoCreditoTab = '';
        }
      }
    },
    async getComprobantes() {
      this.loadingComprobantes = true;
      const url = `${API_URL}api/comprobantes/${this.legajo}`;
      const header = {
        headers: {
          token: this.token,
        },
      };
      try {
        const r = await axios.get(url, header);
        this.comprobantes = r.data.comprobantes.map((c) => ({
          ...c,
          sel: false,
        }));
        this.listadoFlag = true;
      } catch (error) {
        console.error('Error al obtener comprobantes:', error);
      } finally {
        this.loadingComprobantes = false;
      }
    },
    async liquidar() {
      const saldo = this.montosLiquidados.restoCompletar.toFixed(2);

      await this.$swal
        .fire({
          title:
            '¿Esta seguro que desea liquidar los comprobantes seleccionados?',
          showDenyButton: true,
          confirmButtonText: 'Liquidar',
          denyButtonText: 'Cancelar',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loadingLiquidar = true;
            const url = `${API_URL}api/desembolso/liquidar`;
            const header = {
              headers: {
                token: this.token,
              },
            };
            const data = {
              comprobantes: this.comprobante.filter(
                (c) => c.sel === true && typeof c.id === 'number'
              ),
              lineaCreditoCliente_id: this.legajo,
              lineaCredito_id: this.operatoria.id,
            };
            await axios.post(url, data, header).then((r) => {
              if (r.data.status === 'error') {
                this.$swal.fire(r.data.message, '', 'error');
              } else {
                this.$swal
                  .fire({
                    title: 'Se ha realizado la liquidación',
                    confirmButtonText: 'Aceptar',
                  })
                  .then(async (rdo) => {
                    if (rdo.isConfirmed) {
                      // this.$router.go(`${this.$router.currentRoute.path}#liquidaciones`);
                      this.$router.push('#liquidaciones');
                      this.$router.go(0);
                    }
                  });
              }
            });
          }
        });
      if (saldo <= 0) {
        await this.cerrarSolicitud();
      }
    },

    async cerrarSolicitud() {
      const url = `${API_URL}api/solicitud/cambiarestado`;
      const data = {
        lineaCreditoCliente_id: this.legajo,
        estado: 11,
      };
      const header = {
        headers: {
          token: this.token,
        },
      };
      this.$swal
        .fire({
          title: `¿Desea cambiar el estado de este Legajo/crédito de 'Aprobado' a 'Cerrado'? `,
          showDenyButton: true,
          confirmButtonText: 'Confirmar',
          denyButtonText: 'Cancelar',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            axios.post(url, data, header).then((r) => {
              this.$swal.fire(r.data.message, '', 'success');
              this.$router.go(`${this.$router.currentRoute}#liquidaciones`);
            });
          }
        });
    },
    async getLiquidaciones() {
      // this.loadingLiquidar = true;
      const url = `${API_URL}api/desembolso/liquidaciones/${this.legajo}`;
      const header = {
        headers: {
          token: this.token,
        },
      };
      await axios.get(url, header).then((r) => {
        this.liquidaciones = r.data.liquidaciones;
        this.existeAnticipo = this.liquidaciones
          .map(({ anticipo }) => anticipo)
          .includes(true);
      });
      this.reRender += 1;
    },
    async getGastos() {
      try {
        const desembolsoId = '0';
        const legajo = this.legajo.toString();
        const query = {
          method: 'get',
          // url: `${API_URL}api/gastos/cc`,
          url: `${API_URL}api/v1/gastos/legajo/${legajo}/desembolso/${desembolsoId}`,
          headers: {
            token: this.token,
          },
        };
        const {
          data: { status, response },
        } = await axios(query);

        if (status === 'success') {
          this.gastos = response;
        }
        if (status === 'error') {
          console.log(`Error ${message} statusCode: ${statusCode}`);
        }
        this.localReRender += 1;
      } catch (error) {
        console.error(error);
      }
    },
    async getServicioParametro() {
      if (typeof this.operatoria.id !== 'undefined') {
        axios
          .get(
            `${API_URL}api/servicioParametros/operatoria/${this.lcc.lineaCredito_id}`,
            {
              headers: {
                token: localStorage.getItem('token'),
              },
            }
          )
          .then((response) => {
            const { parametros } = response.data;
            try {
              const parametroValues = {};

              parametros.forEach((param) => {
                const clave = param.tipo_parametro_id.clave;
                parametroValues[clave] = param.valor;
              });
              this.monto_max = parametroValues['monto_maximo'] || 0;
              this.monto_min = parametroValues['monto_minimo'] || 0;
              this.monto_max_anr = parametroValues['monto_max_anr'] || 0;
              this.monto_min_anr = parametroValues['monto_min_anr'] || 0;
              this.max_liquidacion = parametroValues['max_liquidacion'] || 0;
              this.reintegro_total = parametroValues['reintegro'] || 0;
              this.anticipo = parametroValues['anticipo'] || 0;
              this.numero_desembolsos = parametroValues['desembolsos_anr'] || 0;
              this.max_liquidacion = parametroValues['max_liquidacion'] || 0;
              this.subtipo = parametroValues['subtipo_mza_activa'] || 0;
            } catch (err) {
              console.log(err);
              this.max_liquidacion = 0;
            }
          })
          .catch((e) => {
            console.info(e);
          });
      }
    },
    existeDictamen() {
      const url = `${API_URL}api/solicitud/existeDictamen/${this.legajo}`;
      const header = {
        headers: {
          token: localStorage.getItem('token'),
        },
      };
      axios.get(url, header).then((r) => {
        this.tieneDictamen = r.data.dictamen;
      });
    },
    async getLcc() {
      const url = `${API_URL}api/servicioClientes/${this.legajo}`;
      const { data } = await axios.get(url, {
        headers: {
          token: localStorage.getItem('token'),
        },
      });
      const [lcc] = data.lineaCreditoCliente;
      this.lcc = lcc;
      this.operId = lcc.lineaCredito_id;
      await this.getServicioParametro();
      this.getDocumentacion();
    },
    async liquidarEnlace() {
      const url = `${API_URL}api/solicitud/liquidacionEnlace/${this.legajo}`;
      const { data } = await axios.get(url, {
        headers: {
          token: localStorage.getItem('token'),
        },
      });
      this.lcc = data.lineaCreditoCliente;
    },
    async liquidarSubtipo() {
      const url = `${API_URL}api/solicitud/liquidacionSubtipo`;
      const concepto =
        'Comprobante Generico para Mendoza Activa II: Cultura y Turismo';
      const neto = this.clienteParametro.find(
        (e) => e.tipo_parametro_id.clave === 'monto_desembolso'
      ).valor;
      const header = {
        headers: {
          token: this.token,
        },
      };
      const data = {
        lineaCreditoCliente_id: this.legajo,
        neto,
        concepto,
      };
      axios.post(url, data, header).then((response) => {
        this.lcc = response;
        this.monto_subtipo = neto;
        if (response.data.status === 'error') {
          this.$swal.fire(
            'Ocurrió un error',
            'No se pudieron obtener los parametros ingresados por el cliente',
            'warning'
          );
        } else {
          this.$swal
            .fire({
              title: 'Se ha realizado la liquidación',
              confirmButtonText: 'Aceptar',
            })
            .then(async (rdo) => {
              if (rdo.isConfirmed) {
                this.$router.go(0);
              }
            });
        }
      });
    },
    async descargarDoc(listDocumentos) {
      //  Crea un objeto JSZip
      const zip = new JSZip();
      const apellido =
        this.cliente.razonSocial.toUpperCase() ||
        this.cliente.apellido.toUpperCase();
      // Por cada archivo en la lista
      for (const archivo of listDocumentos) {
        const formatUrl = archivo.cliente.url;
        //nombre q tiene el archivo en bd
        const nombreArchivo = archivo.cliente.nombre || 'sin nombre';
        // Agrega el archivo al archivo ZIP
        zip.file(
          nombreArchivo,
          await fetch(formatUrl).then((response) => response.blob())
        );
      }

      // Genera el contenido del archivo ZIP
      const zipContent = await zip.generateAsync({ type: 'blob' });
      // Crea un enlace para descargar el archivo ZIP
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(zipContent);
      downloadLink.download = `Doc.-${apellido}-${this.legajo}.zip`;
      downloadLink.click();
    },
    getDocumentacion() {
      const url = `${API_URL}api/documentacionClientes/servicio/${this.operId}/${this.legajo}`;
      const header = {
        headers: {
          'Content-Type': 'application/json',
          token: this.token,
        },
      };
      axios.get(url, header).then((response) => {
        const rol = localStorage.getItem('rol');

        if (!response.data.listaDocumentosCliente) {
          console.log('No posee doc.');
          this.listDocumentos = [];
          return;
        }
        const docs = response.data.listaDocumentosCliente
          .filter((el) => el.documento_maestro)
          .map((el) => {
            let validationRol;
            if (!el.documento_maestro) {
              return;
            }
            if (rol === '5') {
              validationRol = el.documento_maestro.tipo_analisis === 'Legal';
            } else {
              validationRol = el.documento_maestro.tipo_analisis !== 'Legal';
            }

            return {
              ...el,
              validacionRol: validationRol,
            };
          });

        this.listDocumentos = docs;
        // this.EstadoDocumentos = _.groupBy(
        //   docs,
        //   (d) => d.documento_maestro.tipo_analisis
        // );
      });
    },
  },
  computed: {
    montosLiquidados() {
      let liquidados_iva = this.liquidaciones.map((el) => el.total_iva);
      if (liquidados_iva.length !== 0) {
        liquidados_iva = liquidados_iva.reduce((a, b) => a + b);
      } else {
        liquidados_iva = 0;
      }
      let comprobantes_iva = this.comprobantes.filter(
        (el) => el.rechazado === false
      );
      if (comprobantes_iva.length !== 0) {
        comprobantes_iva = comprobantes_iva
          .map((el) => el.neto_iva)
          .reduce((a, b) => a + b);
      } else {
        comprobantes_iva = 0;
      }
      const liquidacion_aprabada = this.clienteParametro.find(
        (el) =>
          el.tipo_parametro_id &&
          el.tipo_parametro_id.clave === 'liquidacion_aprobada'
      );
      const total_liquidacion = liquidacion_aprabada
        ? liquidacion_aprabada.valor
        : 0;
      const sumLiquidadoYsumComprobantes = liquidados_iva + comprobantes_iva;

      const restoCompletar = total_liquidacion - sumLiquidadoYsumComprobantes;
      if (sumLiquidadoYsumComprobantes > total_liquidacion) {
        return { liquidados_iva, excede: true, restoCompletar };
      }
      return { liquidados_iva, excede: false, restoCompletar };
    },
  },

  async created() {
    this.formatMonto = formatMonto;

    // Inicializar editMode explícitamente
    this.$set(this.editMode, 'cbu_financiamiento', false);
    this.$set(this.editMode, 'fechaCreacion', false);

    this.getLcc();
    this.getLiquidaciones();
    this.getGastos();
    this.getListaSolicitudEstado();
    this.getBitacora();
    this.getEstadoAnalisis();
    this.getClienteParametros();
    this.existeDictamen();
    this.oldLegajo = this.legajo;
    this.operId = this.operatoria.id;
    this.getDocumentacion();
  },
};
</script>
<style>
.swal2-title,
.swal2-content,
.swal2-styled {
  font-family: Roboto, sans-serif !important;
}
.my-container {
  display: flex;
  justify-content: flex-end;
}

.disabled-row {
  opacity: 0.5;
  pointer-events: none;
}

/* Edit functionality styles */
.content-area {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.content-area .v-text-field,
.content-area .v-select {
  min-width: 150px;
}

/* Ensure action buttons don't get compressed */
.ml-2 {
  flex-shrink: 0;
  min-width: fit-content;
}

/* Better responsive behavior */
@media (max-width: 768px) {
  .content-area {
    margin-right: 8px;
  }

  .content-area .v-text-field,
  .content-area .v-select {
    min-width: 120px;
  }
}
</style>
